(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoicePatientDialogController', InvoicePatientDialogController);

    InvoicePatientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoicePatient'];

    function InvoicePatientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoicePatient) {
        var vm = this;

        vm.invoicePatient = entity;
        vm.datePickerOpenStatus = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            InvoicePatient.adjust(vm.invoicePatient, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:invoicePatientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
